
import { Vue, Component } from 'vue-property-decorator';

@Component({
  props: {
    main: Boolean,
    galleryList: Boolean,
  },
  computed: {
    classObject() {
      return {
        [this.$style.root]: true,
        [this.$style.main]: this.$props.main,
        [this.$style['gallery-list']]: this.$props.galleryList,
      };
    },
  },
})
export default class IndentedContainer extends Vue {}
